/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class QueryOperatorBinaryLogicForGraph extends models.QueryOperatorBinaryForGraph {
    constructor() {
        super();
        this.setDiscriminator("QueryOperatorBinaryLogicForGraph");
    }

    getFixupPrototypeFunction() { return QueryOperatorBinaryLogicForGraph.fixupPrototype; }

    static newInstance(model: Partial<QueryOperatorBinaryLogicForGraph>): QueryOperatorBinaryLogicForGraph {
        let obj = Object.assign(new QueryOperatorBinaryLogicForGraph(), model);
        QueryOperatorBinaryLogicForGraph.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<QueryOperatorBinaryLogicForGraph>): QueryOperatorBinaryLogicForGraph {
        if (!model) return null;
        return QueryOperatorBinaryLogicForGraph.newInstance(<QueryOperatorBinaryLogicForGraph> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: QueryOperatorBinaryLogicForGraph) {
        if (!obj) return;

        models.QueryOperatorBinaryLogicForGraph.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: QueryOperatorBinaryLogicForGraph): boolean {
        if (models.QueryOperatorBinaryForGraph.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, QueryOperatorBinaryLogicForGraph.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Type of binary operation
     */
    op: models.ResourceQueryCondition;

}
